import usePackage from 'context/package-context/hook'
import { Card } from 'external/react'

import PackageItem from './PackageItem'

import SelectUserModal from 'pages/home/packages/dialogs/SelectUserModal'

import {studentAssignmentWarning} from 'pages/home/packages/dialogs/StudentAssignmentWarning'

import ChangePackageAliasModal from './ChangePackageAliasModal'
import PurchasePackage from './PackageItem/PurchasePackage'
import { Package, PackageUser } from 'types/context/package'


export default function Packages() {

	const {update, state: {packages}, assignUserToPackage} = usePackage()

	async function handleUserSelection (role: string, selectedUser: PackageUser | null, purchase: Package | null) {
		if (selectedUser && purchase) {
			const isConfirmed = role === 'Student' && (await studentAssignmentWarning()) || role === 'Tutor' 
			if (isConfirmed) {
				await assignUserToPackage(role, selectedUser?.id, purchase?.id)
				update({packages: {items: {[purchase.index]: {
					[role.toLowerCase()]: {$set: {id: selectedUser.id, name: selectedUser.name}}
				}}}})
			}
		}
	}

	return (
		<Card.Body className='mt-2'>
			<ChangePackageAliasModal />
			<SelectUserModal onSelectUser={handleUserSelection} role='Student' />
			<SelectUserModal onSelectUser={handleUserSelection} role='Tutor' />
			<div className='row'>
				{packages.items.map((item, index:number) => (<PackageItem key={index} index={index} item={item} />))}
				<PurchasePackage />
			</div>
		</Card.Body>
	)
}